/* eslint-disable @typescript-eslint/no-explicit-any */
import { RequestError } from '@mottmac-moata/identity-sdk';

const isRequestError = (value: any): value is RequestError => value.name === 'RequestError';

export default isRequestError;
